import React from "react";
import { useT } from "@/i18n/I18nContext";
import MilestoneOverlay from "./MilestoneOverlay";

// Localised headline — kept inline to sidestep the missing-key fallback
// gotcha (see WaterMilestone2LOverlay for the same pattern).
const COPY = {
  it: "Training completato! 💪",
  en: "Workout done! 💪",
  de: "Training geschafft! 💪",
  fr: "Entraînement fait ! 💪",
};

/**
 * Training-complete celebration overlay. Fires each time the user
 * actually saves a workout (see Workouts.jsx handleWorkoutSaved).
 * The subtitle line is intentionally hidden per the design brief —
 * only the mascot + short headline shows unless the user just earned
 * SP or extended a streak, in which case a small chip renders.
 */
export default function TrainingCompleteOverlay({ show, onClose, bonusSp = null, streak = null }) {
  const { lang } = useT();
  const chips = [];
  if (bonusSp && bonusSp > 0) chips.push(`+${bonusSp} SP`);
  if (streak && streak > 1) chips.push(`🔥 ${streak}`);
  return (
    <MilestoneOverlay
      show={show}
      onClose={onClose}
      mascotSrc="/mascot/fitness-512.png"
      mascotAlt="Solano"
      title={COPY[lang] || COPY.it}
      subtitle={chips.length ? chips.join(" · ") : null}
      confettiColors={["#E8951C", "#FFB84D"]}
      size="lg"
      testId="training-done-overlay"
    />
  );
}
